export default __webpack_public_path__ + "static/media/input-icon.9de28c74.svg";